import * as React from 'react';
import './ReturnsView.scss';
import ReturnsDesktop from './components/ReturnsDesktop';
import ReturnsMobile from './components/ReturnsMobile';
import ReturnsCartModal from './components/ReturnsCartModal';
import ReturnsCartSlide from './components/ReturnsCartSlide';
import {
  IEligibleFilter,
  IEligibleResponse,
  IStatusFilter,
  IStatusResponse,
  IReturnDetail,
  IEligibleItem
} from 'src/services/returns/typings';
import BarcodeModal from './components/BarcodeModal';
import ReturnsRmaModal from './components/ReturnsRmaModal';
import ReturnsRmaSlide from './components/ReturnsRmaSlide';
import DeleteReturnModal from './components/StatusTab/components/DeleteReturnModal';
import { ERmaStatus } from './components/StatusTab/StatusTab';
import returnsServiceInstance from 'src/services/returns/returnsService';
import { downloadFile } from 'src/utils/downloadHelper';
import LocaleFormating from 'src/translation/localeFormating';
import UserModel from 'src/model/user.model';
import Downloadloader from 'src/components/common/Downloadloader';

interface IReturnsViewProps {
  getEligibleItems: (body?: IEligibleFilter, queryParams?: string) => void;
  getEligibleCoreItems: (body?: IEligibleFilter, queryParams?: string) => void;
  clearPartsToReturn: () => void;
  eligibleData: IEligibleResponse;
  eligibleCoreData: IEligibleResponse;
  getStatusItems: (body?: IStatusFilter, queryParams?: string) => void;
  statusData: IStatusResponse;
  onDeleteRmaList: (rmaNumber: string, callback: () => void) => void;
  getRMALists: (body?: IStatusFilter) => void;
  partsToReturn: IEligibleItem[];
  userData: UserModel;
}

export const RMA_EDIT = 'edit';
export const RMA_SUBMIT = 'submit';

export interface IRmaModalData {
  action: string;
  data: IReturnDetail[];
  rmaNumber: string;
  poNumber?: string;
}

export interface IToggleModalOptions {
  show: boolean;
  onCancel: () => void;
  onGranted: () => void;
}

const ReturnsView: React.FC<IReturnsViewProps> = props => {
  const {
    clearPartsToReturn,
    getEligibleItems,
    eligibleData,
    eligibleCoreData,
    getEligibleCoreItems,
    getStatusItems,
    statusData,
    onDeleteRmaList,
    getRMALists,
    partsToReturn,
    userData
  } = props;

  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [showCounter, setShowCounter] = React.useState<boolean>(false);
  const [forItem, setForItem] = React.useState<string>('');
  const [showCounterStatus, setShowCounterStatus] = React.useState<boolean>(false);
  const [forItemStatus, setForItemStatus] = React.useState<string>('');
  // ELIGIBLE TAB
  const [currentPageEligible, setCurrentPageEligible] = React.useState<number>(0);
  const [sortEligible, setSortEligible] = React.useState<string[]>([]);
  const [selectedTypeOfItem, setSelectedTypeOfItem] = React.useState<string>('part');
  const [dates, setDates] = React.useState<any>(null);
  const [search, setSearch] = React.useState<any>(null);
  const [showReturnCartModal, setShowReturnCartModal] = React.useState<boolean>(false);
  const [toggleModalOptions, setToggleModalOptions] = React.useState<IToggleModalOptions>({
    show: false,
    onCancel: () => null,
    onGranted: () => null
  });
  // STATUS TAB
  const [
    selectedTypeOfItemStatus,
    setSelectedTypeOfItemStatus
  ] = React.useState<string>('part');
  const [filter, setFilter] = React.useState('');
  const [searchStatus, setSearchStatus] = React.useState<any>(null);
  const [currentPageStatus, setCurrentPageStatus] = React.useState<number>(0);
  const [currentPageSsize, setCurrentPageSizeStatus] = React.useState<number>(0);
  const [currentPageSsizeEligible, setCurrentPageSizeEligible] = React.useState<number>(0);
  const [sortStatus, setSortStatus] = React.useState<string[]>([]);
  const [showReturnRmaModal, setShowReturnRmaModal] = React.useState<boolean>(false);
  const [selectedReturnToDelete, setSelectedReturnToDelete] = React.useState<string>(null);
  const [rmaModalData, setRmaModalData] = React.useState<IRmaModalData>({data: [],
    action: '',
    rmaNumber: '',
    poNumber: ''
  });
  const [showBarcodeModal, setShowBarcodeModal] = React.useState<boolean>(false);
  const [rmaBarcode, setRmaBarcode] = React.useState<string>('');
  const [upsResponseDataForBarcodeModal,setUpsResponseDataForBarcodeModal]=React.useState([]);
  const [upsRequestDataForBarcodeModal,setUpsRequestDataForBarcodeModal]=React.useState([]);
  const [downloadShowLoaderOnAction, setDownloadShowLoaderOnAction] = React.useState(false);
  const [downloadShowLoaderOnActionStatus, setDownloadShowLoaderOnActionStatus] = React.useState(false);
  const [upsShippingErrorMessageForBarcodeModal, setUpsShippingErrorMessageForBarcodeModal] = React.useState<string>(null);

  React.useEffect(() => {
    if (selectedTypeOfItem === 'usedCore' || selectedTypeOfItem === 'part') {
      setCurrentPageEligible(0);
      clearPartsToReturn();
    }

    return () => {
      clearPartsToReturn();
    };
  }, [selectedTypeOfItem]);

  React.useEffect(() => {
    if (selectedTypeOfItem === 'usedCore' || selectedTypeOfItem === 'part') {
      setCurrentPageStatus(0);
    }
  }, [selectedTypeOfItemStatus]);

  React.useEffect(() => {
    setCurrentPageEligible(0);
  }, [dates, search]);

  React.useEffect(() => {
    setCurrentPageStatus(0);
  }, [filter, searchStatus]);

  React.useEffect(() => {
    if (selectedTypeOfItem === 'part') {
      getEligibleItems(
        {
          dateFrom: dates ? dates.start.format('YYYY-MM-DD') : undefined,
          dateTo: dates ? dates.end.format('YYYY-MM-DD') : undefined,
          [search && search.searchBy]: search ? search.query : undefined
        },
        `page=${currentPageEligible}${
          currentPageSsizeEligible > 0
            ? '&size=' + currentPageSsizeEligible
            : ''
        }${sortEligible.length > 0 ? '&sort=' : ''}${sortEligible.join(
          '&sort='
        )}`
      );
      getRMALists({
        itemType: 'PART',
        rmaListStatus: ERmaStatus.NOT_SUBMITTED
      });
    } else if (selectedTypeOfItem === 'usedCore') {
      getEligibleCoreItems(
        {
          dateFrom: dates ? dates.start.format('YYYY-MM-DD') : undefined,
          dateTo: dates ? dates.end.format('YYYY-MM-DD') : undefined,
          [search && search.searchBy]: search ? search.query : undefined
        },
        `page=${currentPageEligible}${
          currentPageSsizeEligible > 0
            ? '&size=' + currentPageSsizeEligible
            : ''
        }${sortEligible.length > 0 ? '&sort=' : ''}${sortEligible.join(
          '&sort='
        )}`
      );
      getRMALists({
        itemType: 'CORE',
        rmaListStatus: ERmaStatus.NOT_SUBMITTED
      });
    }
  }, [
    dates,
    search,
    selectedTypeOfItem,
    currentPageEligible,
    sortEligible,
    currentPageSsizeEligible
  ]);

  React.useEffect(() => {
    if (selectedTypeOfItemStatus === 'part') {
      getStatusItems(
        {
          itemType: 'PART',
          rmaListStatus: filter,
          [searchStatus && searchStatus.searchBy]: searchStatus
            ? searchStatus.query
            : undefined
        },
        `page=${currentPageStatus}${
          currentPageSsize > 0 ? '&size=' + currentPageSsize : ''
        }${sortStatus.length > 0 ? '&sort=' : ''}${sortStatus.join('&sort=')}`
      );
    } else if (selectedTypeOfItemStatus === 'usedCore') {
      getStatusItems(
        {
          itemType: 'CORE',
          rmaListStatus: filter,
          [searchStatus && searchStatus.searchBy]:
            searchStatus && searchStatus.query
        },
        `page=${currentPageStatus}${
          currentPageSsize > 0 ? '&size=' + currentPageSsize : ''
        }${sortStatus.length > 0 ? '&sort=' : ''}${sortStatus.join('&sort=')}`
      );
    }
  }, [
    searchStatus,
    filter,
    selectedTypeOfItemStatus,
    currentPageStatus,
    sortStatus,
    currentPageSsize
  ]);

  const selectTab = (index: number) => {
    setCurrentTab(index);
  };

  const handlePaginationEligible = (type: 'next' | 'previous') => {
    let data = eligibleData;

    if (selectedTypeOfItem === 'part') {
      data = eligibleData;
    } else {
      data = eligibleCoreData;
    }

    if (type === 'previous') {
      if (data.pageNumber !== 0) {
        setCurrentPageEligible(data.pageNumber - 1);
      }
    } else {
      if (data.pageNumber !== data.totalPages) {
        setCurrentPageEligible(data.pageNumber + 1);
      }
    }
  };

  const handlePaginationStatus = (type: 'next' | 'previous') => {
    if (type === 'previous') {
      if (statusData.pageNumber !== 0) {
        setCurrentPageStatus(statusData.pageNumber - 1);
      }
    } else {
      if (statusData.pageNumber !== statusData.totalPages) {
        setCurrentPageStatus(statusData.pageNumber + 1);
      }
    }
  };

  const handleSortItemsEligible = (option: string) => {
    const sortFiltered = sortEligible.map(s => s.split(',')[0]);
    const indexFiltered = sortFiltered.indexOf(option.split(',')[0]);
    const indexSort = sortEligible.indexOf(option);

    if (indexSort === -1 && indexFiltered === -1) {
      // INSERT
      setSortEligible([...sortEligible, option]);
    } else if (indexSort !== -1 && indexFiltered !== -1) {
      // REMOVE
      setSortEligible(sortEligible.filter((el, i) => i !== indexSort));
    } else if (indexSort === -1 && indexFiltered !== -1) {
      // SUBSTITUTE
      const newSortEligible = sortEligible.filter(
        (el, i) => i !== indexFiltered
      );
      setSortEligible([...newSortEligible, option]);
    }
  };

  const handleSortItemsStatus = (option: string) => {
    const sortFiltered = sortStatus.map(s => s.split(',')[0]);
    const indexFiltered = sortFiltered.indexOf(option.split(',')[0]);
    const indexSort = sortStatus.indexOf(option);

    if (indexSort === -1 && indexFiltered === -1) {
      // INSERT
      setSortStatus([...sortStatus, option]);
    } else if (indexSort !== -1 && indexFiltered !== -1) {
      // REMOVE
      setSortStatus(sortStatus.filter((el, i) => i !== indexSort));
    } else if (indexSort === -1 && indexFiltered !== -1) {
      // SUBSTITUTE
      const newSortStatus = sortStatus.filter((el, i) => i !== indexFiltered);
      setSortStatus([...newSortStatus, option]);
    }
  };

  const handleSelectedTypeOfItem = (type: any) => {
    if (partsToReturn.length === 0) {
      setSelectedTypeOfItem(type);
    } else {
      setToggleModalOptions({
        show: true,
        onCancel: () => {
          setToggleModalOptions({
            show: false,
            onCancel: () => null,
            onGranted: () => null
          });
        },
        onGranted: () => {
          setSelectedTypeOfItem(type);
          setToggleModalOptions({
            show: false,
            onCancel: () => null,
            onGranted: () => null
          });
        }
      });
    }
  };

  const handleSelectedTypeOfItemStatus = (type: any) => {
    setSelectedTypeOfItemStatus(type);
  };

  const handleDateChange = (date: any) => {
    setDates(date);
  };

  const handleClickSearch = (searchBy: string, query: string) => {
    setSearch({
      searchBy,
      query
    });

    if (query) {
      setShowCounter(true);
      setForItem(query);
    } else {
      setShowCounter(false);
      setForItem('');
    }
  };

  const handleClickSearchStatus = (searchBy: string, query: string) => {
    setSearchStatus({
      searchBy,
      query
    });
    if (query) {
      setShowCounterStatus(true);
      setForItemStatus(query);
    } else {
      setShowCounterStatus(false);
      setForItemStatus('');
    }
  };

  const handleShowCartModal = (state: boolean) => {
    setShowReturnCartModal(state);
  };

  const handleShowRmaModal = (state: boolean, data: IRmaModalData) => {
    setShowReturnRmaModal(state);
    setRmaModalData(data);
  };

  const handleDeleteRmaList = () => {
    onDeleteRmaList(selectedReturnToDelete, () => {
      setSelectedReturnToDelete(null);
      getStatusItems({
        itemType: selectedTypeOfItemStatus === 'part' ? 'PART' : 'CORE',
        rmaListStatus: filter,
        [searchStatus && searchStatus.searchBy]: searchStatus
          ? searchStatus.query
          : undefined
      });
      getRMALists({
        itemType: selectedTypeOfItemStatus === 'part' ? 'PART' : 'CORE',
        rmaListStatus: ERmaStatus.NOT_SUBMITTED
      });
    });
  };

  const handleOpenBarcodeModal = (rmaNumber: string,upsResponseData:any[]) => {
    setRmaBarcode(rmaNumber);
    setUpsResponseDataForBarcodeModal(upsResponseData);
    setShowBarcodeModal(true);
  };

 
  const handleShippingLabelErrorMessageForPrintPopup = (shippingErrorMessage:string) => {
    setUpsShippingErrorMessageForBarcodeModal(shippingErrorMessage);
  };
  
  const clearStatusFilters = () => {
    setFilter('');
    setSearchStatus(null);
    setShowCounterStatus(false);
    setForItemStatus('');
    setCurrentPageStatus(0);
  };

  const clearEligibleFilters = () => {
    setDates(null);
    setSearch(null);
    setShowCounter(false);
    setForItem('');
    setCurrentPageEligible(0);
  };

  const handleDesktopPaginationEligible = (pageNumber: number) => {
    setCurrentPageEligible(pageNumber - 1);
  };

  const handlePageSizeChangeEligible = (pageSize: any) => {
    setCurrentPageSizeEligible(pageSize);
    setCurrentPageEligible(0);
  };

  const handleDesktopPaginationStatus = (pageNumber: number) => {
    setCurrentPageStatus(pageNumber - 1);
  };

  const handlePageSizeChangeStatus = (pageSize: any) => {
    setCurrentPageSizeStatus(pageSize);
    setCurrentPageStatus(0);
  };

  const handleMenuItemClick = (event: any, index: number) => {

    // Get Search Filter from line no 138
    const currentPageSsizeE=1000;
    setDownloadShowLoaderOnAction(true);

    if (selectedTypeOfItem === 'part') {
    returnsServiceInstance.getEligibleItemsExport( {
      dateFrom: dates ? dates.start.format('YYYY-MM-DD') : undefined,
      dateTo: dates ? dates.end.format('YYYY-MM-DD') : undefined,
      [search && search.searchBy]: search ? search.query : undefined
    },
    `page=${currentPageEligible}${
      currentPageSsizeE > 0
        ? '&size=' + currentPageSsizeE
        : ''
    }${sortEligible.length > 0 ? '&sort=' : ''}${sortEligible.join(
      '&sort='
    )}&type=${event}`).then(returnExportData => {
      if(event==="xlsx"){
        setDownloadShowLoaderOnAction(false);
        downloadFile(
          returnExportData,
          `All_Eligible_Returns_${LocaleFormating.getNowDate('short')}.xlsx`
        );
      }

      if(event==="pdf"){
        setDownloadShowLoaderOnAction(false);
        downloadFile(
          returnExportData,
          `All_Eligible_Returns_${LocaleFormating.getNowDate('short')}.pdf`
        );
      }

      if(event==="csv"){
        setDownloadShowLoaderOnAction(false);
        downloadFile(
          returnExportData,
          `All_Eligible_Returns_${LocaleFormating.getNowDate('short')}.csv`
        );
      }
    });
    }else if (selectedTypeOfItem === 'usedCore') {
      returnsServiceInstance.getEligibleItemsExportCore( {
        dateFrom: dates ? dates.start.format('YYYY-MM-DD') : undefined,
        dateTo: dates ? dates.end.format('YYYY-MM-DD') : undefined,
        [search && search.searchBy]: search ? search.query : undefined
      },
      `page=${currentPageEligible}${
        currentPageSsizeE > 0
          ? '&size=' + currentPageSsizeE
          : ''
      }${sortEligible.length > 0 ? '&sort=' : ''}${sortEligible.join(
        '&sort='
      )}&type=${event}`).then(returnExportData => {
        if(event==="xlsx"){
          setDownloadShowLoaderOnAction(false);
          downloadFile(
            returnExportData,
            `All_Eligible_Returns_Core_${LocaleFormating.getNowDate('short')}.xlsx`
          );
        }
  
        if(event==="pdf"){
          setDownloadShowLoaderOnAction(false);
          downloadFile(
            returnExportData,
            `All_Eligible_Returns_Core_${LocaleFormating.getNowDate('short')}.pdf`
          );
        }
  
        if(event==="csv"){
          setDownloadShowLoaderOnAction(false);
          downloadFile(
            returnExportData,
            `All_Eligible_Returns_Core_${LocaleFormating.getNowDate('short')}.csv`
          );
        }
      });
      } 
    
  };

  const handleMenuItemClickReturnStatus=(event: any, index: number)=>{
    const currentPageSsizeT=1000;
    let itemTypeToSend='';
    // Get Search Filter from line no 188
    setDownloadShowLoaderOnActionStatus(true);
    if (selectedTypeOfItemStatus === 'part') {
      itemTypeToSend="PART";
    }else if (selectedTypeOfItemStatus === 'usedCore') {
      itemTypeToSend="CORE";
     }

      returnsServiceInstance.getStatusItemsExport( {
        rmaListStatus: filter,
        itemType:itemTypeToSend,
        [searchStatus && searchStatus.searchBy]: searchStatus ? searchStatus.query : undefined
      },
      `page=${currentPageStatus}${
        currentPageSsizeT > 0
          ? '&size=' + currentPageSsizeT
          : ''
      }${sortStatus.length > 0 ? '&sort=' : ''}${sortStatus.join(
        '&sort='
      )}&type=${event}`).then(returnStatusExportData => {
        if(event==="xlsx"){
          setDownloadShowLoaderOnActionStatus(false);
          downloadFile(
            returnStatusExportData,
            `All_Return_Status_${itemTypeToSend}_${LocaleFormating.getNowDate('short')}.xlsx`
          );
        }
  
        if(event==="pdf"){
          setDownloadShowLoaderOnActionStatus(false);
          downloadFile(
            returnStatusExportData,
            `All_Return_Status_${itemTypeToSend}_${LocaleFormating.getNowDate('short')}.pdf`
          );
        }
  
        if(event==="csv"){
          setDownloadShowLoaderOnActionStatus(false);
          downloadFile(
            returnStatusExportData,
            `All_Return_Status_${itemTypeToSend}_${LocaleFormating.getNowDate('short')}.csv`
          );
        }
  
      });
      
  }

  return (
    <div className="rp-returns-view">
      { downloadShowLoaderOnAction &&
        <Downloadloader/>
      }
      {downloadShowLoaderOnActionStatus &&
       <Downloadloader/>
      }
      <div className="rp-returns-view-mobile">
        <ReturnsMobile
          currentTab={currentTab}
          selectTab={selectTab}
          eligibleData={
            selectedTypeOfItem === 'part' ? eligibleData : eligibleCoreData
          }
          handlePaginationEligible={handlePaginationEligible}
          handleSortItemsEligible={handleSortItemsEligible}
          sortEligible={sortEligible}
          setSortEligible={setSortEligible}
          selectedTypeOfItem={selectedTypeOfItem}
          selectedTypeOfItemStatus={selectedTypeOfItemStatus}
          handleSelectedTypeOfItem={handleSelectedTypeOfItem}
          handleSelectedTypeOfItemStatus={handleSelectedTypeOfItemStatus}
          selectedDates={dates}
          setSelectedDates={setDates}
          handleDateChange={handleDateChange}
          handleClickSearch={handleClickSearch}
          handleClickSearchStatus={handleClickSearchStatus}
          handlePaginationStatus={handlePaginationStatus}
          handleSortItemsStatus={handleSortItemsStatus}
          sortStatus={sortStatus}
          handleShowCartModal={handleShowCartModal}
          handleShowRmaModal={handleShowRmaModal}
          setSelectedReturnToDelete={setSelectedReturnToDelete}
          filter={filter}
          setFilter={setFilter}
          handleOpenBarcodeModal={handleOpenBarcodeModal}
          showCounter={showCounter}
          forItem={forItem}
          showCounterStatus={showCounterStatus}
          forItemStatus={forItemStatus}
          clearEligibleFilters={clearEligibleFilters}
          clearStatusFilters={clearStatusFilters}
          toggleModalOptions={toggleModalOptions}
          handleDesktopPaginationEligible={handleDesktopPaginationEligible}
          handleDesktopPaginationStatus={handleDesktopPaginationStatus}
          handlePageSizeChangeEligible={handlePageSizeChangeEligible}
          handlePageSizeChangeStatus={handlePageSizeChangeStatus}
          handleMenuItemClick={handleMenuItemClick}
          handleMenuItemClickReturnStatus={handleMenuItemClickReturnStatus}
        />
        <ReturnsCartSlide
          filters={{
            status: filter,
            search: searchStatus
          }}
          typeOfItemEligible={selectedTypeOfItem}
          showSlide={showReturnCartModal}
          closeSlide={() => handleShowCartModal(false)}
          handleOpenBarcodeModal={handleOpenBarcodeModal}
          clearStatusFilters={clearStatusFilters}
          clearEligibleFilters={clearEligibleFilters}
          userData={userData}
          handleShippingLabelErrorMessageForPrintPopup={handleShippingLabelErrorMessageForPrintPopup}
        />

        <ReturnsRmaSlide
          clearStatusFilters={clearStatusFilters}
          clearEligibleFilters={clearEligibleFilters}
          filters={{
            status: filter,
            search: searchStatus
          }}
          typeOfItemStatus={selectedTypeOfItemStatus}
          typeOfItemEligible={selectedTypeOfItem}
          handleOpenBarcodeModal={handleOpenBarcodeModal}
          showSlide={showReturnRmaModal}
          closeSlide={() =>
            handleShowRmaModal(false, {
              data: [],
              action: '',
              rmaNumber: '',
              poNumber: ''
            })
          }
          rmaModalData={rmaModalData}
          userData={userData}
        />
      </div>
      <div className="rp-returns-view-desktop">
        <ReturnsDesktop
          currentTab={currentTab}
          selectTab={selectTab}
          eligibleData={
            selectedTypeOfItem === 'part' ? eligibleData : eligibleCoreData
          }
          handlePaginationEligible={handlePaginationEligible}
          handleSortItemsEligible={handleSortItemsEligible}
          sortEligible={sortEligible}
          setSortEligible={setSortEligible}
          selectedTypeOfItem={selectedTypeOfItem}
          selectedTypeOfItemStatus={selectedTypeOfItemStatus}
          handleSelectedTypeOfItem={handleSelectedTypeOfItem}
          handleSelectedTypeOfItemStatus={handleSelectedTypeOfItemStatus}
          selectedDates={dates}
          setSelectedDates={setDates}
          handleDateChange={handleDateChange}
          handleClickSearch={handleClickSearch}
          handleClickSearchStatus={handleClickSearchStatus}
          handlePaginationStatus={handlePaginationStatus}
          handleSortItemsStatus={handleSortItemsStatus}
          sortStatus={sortStatus}
          handleShowCartModal={handleShowCartModal}
          handleShowRmaModal={handleShowRmaModal}
          setSelectedReturnToDelete={setSelectedReturnToDelete}
          filter={filter}
          setFilter={setFilter}
          handleOpenBarcodeModal={handleOpenBarcodeModal}
          showCounter={showCounter}
          forItem={forItem}
          showCounterStatus={showCounterStatus}
          forItemStatus={forItemStatus}
          clearEligibleFilters={clearEligibleFilters}
          clearStatusFilters={clearStatusFilters}
          toggleModalOptions={toggleModalOptions}
          handleDesktopPaginationEligible={handleDesktopPaginationEligible}
          handleDesktopPaginationStatus={handleDesktopPaginationStatus}
          handlePageSizeChangeEligible={handlePageSizeChangeEligible}
          handlePageSizeChangeStatus={handlePageSizeChangeStatus}
          handleMenuItemClick={handleMenuItemClick}
          handleMenuItemClickReturnStatus={handleMenuItemClickReturnStatus}
        />
        {showReturnCartModal && (
          <ReturnsCartModal
            filters={{
              status: filter,
              search: searchStatus
            }}
            typeOfItemEligible={selectedTypeOfItem}
            closeModal={() => handleShowCartModal(false)}
            handleOpenBarcodeModal={handleOpenBarcodeModal}
            clearStatusFilters={clearStatusFilters}
            clearEligibleFilters={clearEligibleFilters}
            userData={userData}
            handleShippingLabelErrorMessageForPrintPopup={handleShippingLabelErrorMessageForPrintPopup}

          />
        )}
        {showReturnRmaModal && (
          <ReturnsRmaModal
            clearStatusFilters={clearStatusFilters}
            clearEligibleFilters={clearEligibleFilters}
            filters={{
              status: filter,
              search: searchStatus
            }}
            typeOfItemStatus={selectedTypeOfItemStatus}
            typeOfItemEligible={selectedTypeOfItem}
            handleOpenBarcodeModal={handleOpenBarcodeModal}
            handleSelectedTypeOfItemEligible={handleSelectedTypeOfItem}
            closeModal={() =>
              handleShowRmaModal(false, {
                data: [],
                action: '',
                rmaNumber: '',
                poNumber: ''
              })
            }
            rmaModalData={rmaModalData}
            selectTab={selectTab}
            userData={userData}
          />
        )}
      </div>
      {selectedReturnToDelete && (
        <DeleteReturnModal
          onCancel={() => setSelectedReturnToDelete(null)}
          onDelete={handleDeleteRmaList}
        />
      )}
      {showBarcodeModal && (
        <BarcodeModal
          handleCloseModal={() => setShowBarcodeModal(false)}
          rmaBarcode={rmaBarcode}
          upsResponseDataForBarcodeModal={upsResponseDataForBarcodeModal}
          upsShippingErrorMessageForBarcodeModal={upsShippingErrorMessageForBarcodeModal}
        />
      )}
    </div>
  );
};

export default ReturnsView;
